import { takeLatest, put } from 'redux-saga/effects';
import { UserStatus } from 'api/models';
import { UserAPI } from 'api/user';
import { deactivateMemberAction, reactivateMemberAction } from '../actions';
import { updateMember } from '../slice';
function* onError(user, handleFailure = ()=>{}) {
    yield put(updateMember({
        user: {
            userId: user.userId,
            userStatus: user.userStatus
        }
    }));
    handleFailure();
}
function* deactivateMemberSaga(action) {
    const { payload: { userId, handleSuccess, handleFailure } } = action;
    try {
        yield put(updateMember({
            user: {
                userId,
                userStatus: UserStatus.Inactive
            }
        }));
        const state = yield UserAPI.deactivateUser(userId);
        if (state) {
            if (handleSuccess) {
                handleSuccess();
            }
        } else {
            yield onError({
                userId,
                userStatus: UserStatus.Active
            }, handleFailure);
        }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        yield onError({
            userId,
            userStatus: UserStatus.Active
        }, handleFailure);
    }
}
function* reactivateMemberSaga(action) {
    const { payload: { userId, handleSuccess, handleFailure } } = action;
    try {
        yield put(updateMember({
            user: {
                userId,
                userStatus: UserStatus.Active
            }
        }));
        const state = yield UserAPI.reactivateUser(userId);
        if (state) {
            if (handleSuccess) {
                handleSuccess();
            }
        } else {
            yield onError({
                userId,
                userStatus: UserStatus.Inactive
            }, handleFailure);
        }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        yield onError({
            userId,
            userStatus: UserStatus.Inactive
        }, handleFailure);
    }
}
export const watchDeactivateMemberSaga = function*() {
    yield takeLatest(deactivateMemberAction.type, deactivateMemberSaga);
};
export const watchReactivateMemberSaga = function*() {
    yield takeLatest(reactivateMemberAction.type, reactivateMemberSaga);
};
